import React from 'react'
import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import Loading from 'components/Loading'
import Button from 'components/Button'
import { PartnerPlanList, PartnerPlanFilter } from './components/PartnerPlan'
import constants from 'constants'
import { generateCSV } from 'utils/generateCSV'
import Pagination from 'components/Pagination'
// import moment from 'moment'
import { format } from 'date-fns'
import { getCurrentPageData } from 'utils/paging'
import { getEmployeeId } from 'utils/getEmployeeId'
import {
  handleFilterValueFromSession,
  updateFilterSessionObject,
  handleClearFilteredPartnerPlans,
  handleDefaultFilteredData,
  handleChangeFilteredPartnerPlans,
  handlePlanStatusSearchTrigger,
  handlePlanYearTrigger,
} from '../../utils/partnerPlanFilter'
import FeatureGuard from '../../components/FeatureToggle/FeatureGuard'

const styles = Object.assign(
  {},
  require('./PartnerPlans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class PartnerPlansView extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    // getPartnerPlans: PropTypes.func,
    handleIsLoadMore: PropTypes.func.isRequired,
    handleLoadMore: PropTypes.func.isRequired,
    handleSelectedPlan: PropTypes.func.isRequired,
    partnerPlans: PropTypes.object.isRequired,
    planView: PropTypes.string.isRequired,
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    // getPartnerPlans: null,
    selectedPartner: null,
    currentUser: null,
  }

  constructor(props) {
    super(props)
    this.handleClearFilteredPartnerPlans = this.handleClearFilteredPartnerPlans.bind(this)
    this.handleChangeFilteredPartnerPlans = this.handleChangeFilteredPartnerPlans.bind(this)
    this.state = {
      filteredPartnerPlans: [],
      currentPage: {
        CP: 0,
        // ML: 0,
        // BL: 0,
        // CL: 0,
      },
    }
  }

  componentDidMount() {
    const allFilters = handleFilterValueFromSession()
    const { isPlanStatusSearch, isPlanYearSearch } = allFilters
    if (isPlanStatusSearch || isPlanYearSearch) { return }
    // If no filters are applied, reset the filter session object to initial state
    updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL, true, true)
  }

  getPageRecordsCP = (pageIndex) => {
    const currentPage = this.state.currentPage
    const newCurrentPage = merge({}, currentPage, {
      CP: pageIndex,
    })

    this.setState({ currentPage: newCurrentPage })
  }

  /*
  getPageRecordsML = (pageIndex) => {
    const currentPage = this.state.currentPage
    const newCurrentPage = merge({}, currentPage, {
      ML: pageIndex,
    })

    this.setState({ currentPage: newCurrentPage })
  }

  getPageRecordsBL = (pageIndex) => {
    const currentPage = this.state.currentPage
    const newCurrentPage = merge({}, currentPage, {
      BL: pageIndex,
    })

    this.setState({ currentPage: newCurrentPage })
  }

  getPageRecordsCL = (pageIndex) => {
    const currentPage = this.state.currentPage
    const newCurrentPage = merge({}, currentPage, {
      CL: pageIndex,
    })

    this.setState({ currentPage: newCurrentPage })
  }
  */

  handleClearFilteredPartnerPlans = () => {
    handleClearFilteredPartnerPlans({
      setState: this.setState.bind(this),
      props: this.props,
    })
  }

  handleChangeFilteredPartnerPlans = (partnerPlans) => {
    handleChangeFilteredPartnerPlans({
      setState: this.setState.bind(this),
      partnerPlans,
    })
  }

  render() {
    const {
      partnerPlans,
      planView,
      handleSelectedPlan,
      currentUser,
    } = this.props

    if (partnerPlans.isFetching) {
      return (<Loading pageLoading />)
    }

    const allFilters = handleFilterValueFromSession()

    let currentData = (allFilters.isPlanStatusSearch || allFilters.isPlanYearSearch || !allFilters.isInitialLoad)
      ? this.state.filteredPartnerPlans
      : handleDefaultFilteredData(partnerPlans)

    if (allFilters.isClearFilteredData) {
      currentData = this.props.partnerPlans.partnerPlans
    }
    const currentEmployeeId = getEmployeeId(this.props.selectedPartner, this.props.currentUser)

    const cpData = currentData.filter(pp => String(pp.cpEmpId) === String(currentEmployeeId))
    const cpPaging = getCurrentPageData(this.state.currentPage.CP, cpData)

    /* request for Business leader, Market leader and Growth leader to remove from "REVIEW" section
    const mlData = currentData.filter(pp => (String(pp.mlEmpId) === String(currentEmployeeId) && pp.planStatus !== constants.PARTNERPLAN.STATUS.DRAFT))
    const mlPaging = getCurrentPageData(this.state.currentPage.ML, mlData)

    const blData = currentData.filter(pp => (String(pp.blEmpId) === String(currentEmployeeId) && pp.planStatus !== constants.PARTNERPLAN.STATUS.DRAFT))
    const blPaging = getCurrentPageData(this.state.currentPage.BL, blData)

    const clData = currentData.filter(pp => (String(pp.cilEmpId) === String(currentEmployeeId) && pp.planStatus !== constants.PARTNERPLAN.STATUS.DRAFT))
    const clPaging = getCurrentPageData(this.state.currentPage.CL, clData)
    */
    return (
      <FeatureGuard featureName="Plan" user={currentUser}>
        <div className={styles.content}>
          <PartnerPlanFilter
            filteredPartnerPlans={currentData}
            onChangeFilteredPartnerPlans={this.handleChangeFilteredPartnerPlans}
            onClearFilteredPartnerPlans={this.handleClearFilteredPartnerPlans}
            onGetFilterValueFromSession={handleFilterValueFromSession}
            onPlanStatusSearchTrigger={handlePlanStatusSearchTrigger}
            onPlanYearSearchTrigger={handlePlanYearTrigger}
            partnerPlans={partnerPlans}
          />
          <section className={styles.section}>
            {planView === constants.PARTNERPLAN.VIEW.MYPLANS && partnerPlans.fetched && partnerPlans.partnerPlans &&
            <section className={styles.section}>
              <PartnerPlanList
                handleSelectedPlan={handleSelectedPlan}
                header={constants.PARTNERPLAN.ROLE.MYPLANS}
                partnerPlanItems={currentData}
                planView={planView}
                role={constants.PARTNERPLAN.ROLE.MYPLANS}
              />
              { this.props.currentUser.IsAdmin &&
              <div>
                <div className={styles.pagination} />
                <div className={styles.loadMore}>
                  <Button
                    disabled={this.props.handleIsLoadMore()}
                    onClick={() => {
                      this.props.handleLoadMore()
                    }}
                    type="flat"
                  >
                    LOAD MORE
                  </Button>
                </div>
              </div> }
            </section>
            }
          </section>
          {planView === constants.PARTNERPLAN.VIEW.REVIEWPLANS && partnerPlans.fetched && partnerPlans.partnerPlans &&
          <section className={styles.section}>
            <PartnerPlanList
              handleSelectedPlan={handleSelectedPlan}
              header="My counselees"
              partnerPlanItems={cpPaging.currentPageData}
              planView={planView}
              role={constants.PARTNERPLAN.ROLE.CP}
            />
            { cpData.length > 0 ?
              <div>
                { this.props.currentUser.IsAdmin && <div className={styles.loadMore}>
                  <Button
                    disabled={this.props.handleIsLoadMore()}
                    onClick={() => {
                      this.props.handleLoadMore()
                    }}
                    type="flat"
                  >
                    LOAD MORE
                  </Button>
                </div> }
                <div className={styles.pagination}>
                  <Pagination handleChange={this.getPageRecordsCP} pageCount={cpPaging.pageCount} />
                </div>
                <div className={styles.export}>
                  <Button
                    onClick={() => {
                      generateCSV(constants.PARTNERPLAN.CSVHEADER, cpData, `counselling_partnerplan_report_${format(new Date(), constants.DATE_FORMAT.EXPORT_STANDARD)}`)
                  }}
                    type="flat"
                  >
                    EXPORT
                  </Button>
                </div>
              </div>
            : '' }
            {/*
            <PartnerPlanList
              handleSelectedPlan={handleSelectedPlan}
              header={constants.PARTNERPLAN.ROLE.ML}
              partnerPlanItems={mlPaging.currentPageData}
              planView={planView}
            />
            { mlData.length > 0 ?
              <div>
                { this.props.currentUser.IsAdmin && <div className={styles.loadMore}>
                  <Button
                    disabled={this.props.handleIsLoadMore()}
                    onClick={() => {
                      this.props.handleLoadMore()
                    }}
                    type="flat"
                  >
                    LOAD MORE
                  </Button>
                </div> }
                <div className={styles.pagination}>
                  <Pagination handleChange={this.getPageRecordsML} pageCount={mlPaging.pageCount} />
                </div>
                <div className={styles.export}>
                  <Button
                    onClick={() => {
                      generateCSV(constants.PARTNERPLAN.CSVHEADER, mlData, `marketleader_partnerplan_report_${format(new Date(), constants.DATE_FORMAT.EXPORT_STANDARD)}`)
                  }}
                    type="flat"
                  >
                    EXPORT
                  </Button>
                </div>
              </div>
            : '' }
            <PartnerPlanList
              handleSelectedPlan={handleSelectedPlan}
              header={constants.PARTNERPLAN.ROLE.BL}
              partnerPlanItems={blPaging.currentPageData}
              planView={planView}
            />
            { blData.length > 0 ?
              <div>
                { this.props.currentUser.IsAdmin && <div className={styles.loadMore}>
                  <Button
                    disabled={this.props.handleIsLoadMore()}
                    onClick={() => {
                      this.props.handleLoadMore()
                    }}
                    type="flat"
                  >
                    LOAD MORE
                  </Button>
                </div> }
                <div className={styles.pagination}>
                  <Pagination handleChange={this.getPageRecordsBL} pageCount={blPaging.pageCount} />
                </div>
                <div className={styles.export}>
                  <Button
                    onClick={() => {
                      generateCSV(constants.PARTNERPLAN.CSVHEADER, blData, `businessleader_partnerplan_report_${format(new Date(), constants.DATE_FORMAT.EXPORT_STANDARD)}`)
                  }}
                    type="flat"
                  >
                    EXPORT
                  </Button>
                </div>
              </div>
            : '' }
            <PartnerPlanList
              handleSelectedPlan={handleSelectedPlan}
              header={constants.PARTNERPLAN.ROLE.CIL}
              partnerPlanItems={clPaging.currentPageData}
              planView={planView}
            />
            { clData.length > 0 ?
              <div>
                { this.props.currentUser.IsAdmin && <div className={styles.loadMore}>
                  <Button
                    disabled={this.props.handleIsLoadMore()}
                    onClick={() => {
                      this.props.handleLoadMore()
                    }}
                    type="flat"
                  >
                    LOAD MORE
                  </Button>
                </div> }
                <div className={styles.pagination}>
                  <Pagination handleChange={this.getPageRecordsCL} pageCount={clPaging.pageCount} />
                </div>
                <div className={styles.export}>
                  <Button
                    onClick={() => {
                      generateCSV(constants.PARTNERPLAN.CSVHEADER, clData, `growthleader_partnerplan_report_${format(new Date(), constants.DATE_FORMAT.EXPORT_STANDARD)}`)
                    }}
                    type="flat"
                  >
                  EXPORT
                </Button>
                </div>
              </div>
            : '' }
            */}
          </section>
          }
        </div>
      </FeatureGuard>
    )
  }
}

export default PartnerPlansView



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlans.js